import React from 'react';
import { Row } from "reactstrap";
import "./rom-data-section.css";
import RomIcon from "./rom-icon.js"

class PlayerROMSection extends React.Component {
  render() {
    var screenPercentageAVG = Math.round(this.props.rom_data.screen_percentage_avg);

    var screenPercentageText = "N/A";
    if (screenPercentageAVG && screenPercentageAVG !== "") {
       screenPercentageText = screenPercentageAVG + "%";
    }

    var mostUsedROM =  this.props.rom_data.most_used_rom;
    if (!mostUsedROM || mostUsedROM === -1) {
      mostUsedROM = "N/A";
    }

    return (

      <div>
          <Row className='text-left border-bottom range_of_motion_section_title'>
            Range of Motion Summary
          </Row>
          <Row>
            <div className='range_of_motion_summary_section left'>
              <div className="range_of_motion_summary_value_text">{screenPercentageText}</div>
              <div className="mp-0 small secondary-color">Avg. Screen Coverage</div>
            </div>
            <div className='range_of_motion_summary_section right'>
              <div className="range_of_motion_summary_value_text">
                {mostUsedROM === "N/A" ?   mostUsedROM : <RomIcon rom={mostUsedROM}/> }
              </div>
              <div className="mp-0 small secondary-color">Favorite Tracker Range</div>
            </div>
          </Row>
      </div>
    );
  }
}

export default PlayerROMSection;



// WEBPACK FOOTER //
// ./src/components/components/player-overview-charts/rom-data-section.js